import React, { useState, useRef, useEffect } from 'react';
import './NavBar2.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/logos/logo.png';

const NavBar2 = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMobileMenu = () => setMobileMenuOpen(prev => !prev);

  const closeMenuOnOutsideClick = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(e.target)
    ) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeMenuOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeMenuOnOutsideClick);
  }, []);

  return (
    <nav className="NavBar2">
      <div className="NavBar2-logo">
        <img src={logo} alt="Logo" />
        <span>Skript</span>
      </div>

    </nav>
  );
};

export default NavBar2;
